<template>
  <div class="page-container">
    <Sidebar />
    <div class="main-content">
      <AdminTable :apiEndpoint="'/api/admin/favorites'" :columns="columns" :filters="filters" :formFields="formFields" title="收藏记录" />
    </div>
  </div>
</template>
<script>
import Sidebar from '../components/Sidebar.vue'
import AdminTable from '@/components/AdminTable.vue'
export default { name: 'FavoritesList', components: { Sidebar, AdminTable },
  data() { return {
    columns: [{ key: 'id', label: 'ID' }, { key: 'user_id', label: '用户ID' }, { key: 'item_type', label: '类型' }, { key: 'item_id', label: '项目ID' }, { key: 'created_at', label: '时间', type: 'date' }],
    filters: [], formFields: [{ key: 'user_id', label: '用户ID', type: 'number', required: true }, { key: 'item_type', label: '类型', type: 'text', required: true }, { key: 'item_id', label: '项目ID', type: 'number', required: true }]
  } }
}
</script>
<style scoped>
.page-container { display: flex; min-height: 100vh; background: #f5f5f5; }
.main-content { flex: 1; margin-left: 260px; padding: 30px; }
</style>
